import { EditBoolean } from 'components/forms/EditBoolean';
import { EditSelect } from 'components/forms/EditSelect';
import type { ScheduleNext } from 'api/recurrence_definitions/endpoints/types';

import { RESUBMIT_ON_ERROR_DEFAULT_INFO, RESUBMIT_ON_ERROR_IGNORED_ON_START_INFO, SCHEDULE_NEXT_INFO, SCHEDULE_NEXT_OPTIONS } from './scheduleNextOptions';

export interface ScheduleNextFieldsProps {
  readonly scheduleNext: ScheduleNext;
  readonly resubmitOnError: boolean;
  readonly onScheduleNextChange: (value: ScheduleNext) => void;
  readonly onResubmitOnErrorChange: (value: boolean) => void;
}

/**
 * Shared “when to create the next occurrence” + resubmit-on-error pair used by
 * the definition editor, manual submit, and update-instance schedule tab.
 */
export const ScheduleNextFields = ({ scheduleNext, resubmitOnError, onScheduleNextChange, onResubmitOnErrorChange }: ScheduleNextFieldsProps) => (
  <>
    <EditSelect
      label="Schedule next occurrence"
      value={scheduleNext}
      onChange={onScheduleNextChange}
      options={SCHEDULE_NEXT_OPTIONS}
      mandatory
      info={SCHEDULE_NEXT_INFO}
    />
    <EditBoolean
      label="Resubmit on error"
      value={resubmitOnError}
      onChange={onResubmitOnErrorChange}
      info={scheduleNext === 'on_start' ? RESUBMIT_ON_ERROR_IGNORED_ON_START_INFO : RESUBMIT_ON_ERROR_DEFAULT_INFO}
    />
  </>
);
